/**
 * Push Notification Utilities (Web)
 *
 * No-op implementations - web doesn't support native push notifications.
 */

/**
 * Request notification permissions - not supported on web
 */
export async function requestPermissions(): Promise<string | null> {
  return null;
}

/**
 * Check notification status - not supported on web
 */
export async function checkNotificationStatus(): Promise<string | null> {
  return null;
}

/**
 * Set up notification listeners - not supported on web
 */
export function setupNotificationListeners(
  _logEvent: (event: string, properties: Record<string, unknown>) => void,
): void {
  // No-op on web
}
